function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.1099 23.3937V0H35.5543C37.6825 0 39.3768 0.585796 40.6358 1.75743C41.9062 2.92905 42.5414 4.51513 42.5414 6.51574C42.5414 7.38893 42.2793 8.23449 41.7558 9.0524C41.243 9.85928 40.4299 10.4727 39.3153 10.8927C40.7528 11.2575 41.8561 11.9704 42.625 13.0315C43.3939 14.0815 43.7784 15.1481 43.7784 16.2313C43.7784 18.2319 43.0877 19.9285 41.7056 21.3212C40.335 22.7028 38.5129 23.3937 36.2396 23.3937H26.1099ZM31.1413 19.0167H35.9722C36.7632 19.0167 37.3816 18.7293 37.8276 18.1545C38.2736 17.5687 38.4962 16.8945 38.4962 16.1318C38.4962 15.4023 38.2622 14.7557 37.7942 14.192C37.3375 13.6283 36.6963 13.3465 35.8719 13.3465H31.1413V19.0167ZM31.1413 9.23477H35.0695C35.716 9.23477 36.245 9.00817 36.6575 8.55501C37.07 8.10185 37.276 7.52708 37.276 6.83075C37.276 6.07916 37.0808 5.48229 36.6909 5.04016C36.3118 4.59803 35.7602 4.37698 35.0361 4.37698H31.1413V9.23477Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.3524 23.3937V0H59.5962C61.8027 0 63.7196 0.519478 65.3464 1.55847C66.9732 2.59746 68.1934 4.00117 69.0071 5.76966C69.8316 7.52708 70.2441 9.52214 70.2441 11.7549C70.2441 13.9765 69.8316 15.9605 69.0071 17.7069C68.1934 19.4422 66.9732 20.8238 65.3464 21.8518C63.7196 22.8797 61.8027 23.3937 59.5962 23.3937H50.3524ZM55.3504 18.884H59.5962C60.7997 18.884 61.8361 18.5524 62.7053 17.8893C63.5859 17.2261 64.2264 16.3695 64.6276 15.3194C65.0401 14.2584 65.2461 13.0701 65.2461 11.7549C65.2461 10.4285 65.0401 9.22926 64.6276 8.15711C64.2264 7.08495 63.5859 6.21179 62.7053 5.53755C61.8361 4.85227 60.7997 4.50962 59.5962 4.50962H55.3504V18.884Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.002 0V23.3937H82V0H77.002Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.8454 0.480879L17.9377 3.00322C18.1879 3.1565 18.3395 3.42966 18.3395 3.7195V14.9015C18.3395 20.0103 14.0758 24.1492 8.89334 23.9959C3.90431 23.8481 0 19.6563 0 14.7064V10.4532C0 9.98496 0.382073 9.6087 0.851306 9.60592H3.55626C4.19922 9.60592 4.43801 8.77258 3.89296 8.43533L2.89599 7.82215L0.401773 6.28366C0.151635 6.13037 0 5.86003 0 5.56738V1.19994C0 0.536613 0.733102 0.132488 1.30024 0.480879L5.3932 3.00322C5.64334 3.1565 5.79497 3.42685 5.79497 3.7195V14.8039C5.79497 16.5459 7.09521 18.0704 8.8426 18.2349C10.8479 18.4216 12.5421 16.8552 12.5421 14.9015V10.4476C12.5421 9.98218 12.9236 9.60315 13.3928 9.60315H16.1008C16.7437 9.60315 16.9825 8.76977 16.4381 8.43255L15.4405 7.81937L12.9463 6.28089C12.6962 6.1276 12.5445 5.85722 12.5445 5.5646V1.19716C12.5445 0.536613 13.2776 0.132488 13.8454 0.480879Z",
  fill: "white"
});

var SvgUbdiLogo = function SvgUbdiLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 24,
    viewBox: "0 0 82 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUbdiLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ubdi_logo.3fb255f6.svg";
export { ForwardRef as ReactComponent };